import { db, ensureAuthenticated } from "../firebase";
import { collection, getDocs, query, where } from "firebase/firestore";
import { getDeviceId } from "./deviceId";

const MIGRATION_FLAG = "mdmigration_v3_done";

/**
 * Legacy migration: checks whether the current user has any legacy
 * deviceId-based notes/images that still need server-side migration.
 *
 * Client-side updates on notes/images are blocked by Firestore rules
 * (allow update: if false). Actual field migration must be performed
 * via a Cloud Function or Admin SDK script.
 *
 * This function now only acts as a run-once detection pass: it checks
 * whether any docs matched the legacy pattern and logs a warning if so,
 * rather than scanning the entire collection.
 */
export const migrateUserData = async () => {
  if (localStorage.getItem(MIGRATION_FLAG)) return true;

  try {
    await ensureAuthenticated();
    const deviceId = getDeviceId();

    // Scope queries to docs owned by this device — never scan the full collection.
    const notesSnap = await getDocs(
      query(collection(db, "notes"), where("deviceId", "==", deviceId))
    );
    const imagesSnap = await getDocs(
      query(collection(db, "images"), where("deviceId", "==", deviceId))
    );

    if (!notesSnap.empty || !imagesSnap.empty) {
      console.warn(
        `[migrateUserData] ${notesSnap.size + imagesSnap.size} legacy doc(s) found for deviceId ${deviceId}.`,
        "Client-side migration is no longer supported. Run the server-side migration script."
      );
    }

    localStorage.setItem(MIGRATION_FLAG, "1");
    return true;
  } catch (error) {
    // Silently ignore permission errors (user may not own any legacy docs).
    if (error?.code !== "permission-denied") {
      console.error("[migrateUserData] unexpected error:", error);
    }
    localStorage.setItem(MIGRATION_FLAG, "1");
    return false;
  }
};
